import { Box, Text } from "@chakra-ui/react";
import { Container } from "components";

export default function Footer(){
    return(
    <Box maxW="90%" margin="0 auto" textAlign="center" borderTopWidth={1} borderStyle="dotted" mt={8} py={4} px={12}>
        <Text fontSize="xs" color="GrayText">
            Este sistema é monitorado em tempo real. É expressamente proibida a cópia, print ou o compartilhamento de qualquer informação contida aqui para terceiros.
            Qualquer dúvida, problema ou sugestão, encaminhe para <Text as="a" fontWeight="bold" color="orange.800" href="mailto:ti@bonificaoficial.com">ti@bonificaoficial.com</Text> ou contate o supervisor do seu setor. Todos os direitos reservados | Bonífica 2025 | Versão 250611.2303
        </Text>
    </Box>
    )
}